export enum Endpoint {
    BASE_URL = "https://yyhdp5d90l.execute-api.eu-north-1.amazonaws.com",
    STAGE = "/Prod",
    METHOD = "/align"

}
